/* istanbul ignore file */
import { RestrictionMixin } from './RestrictionMixin';
const AssignmentRestrictionParser = 
/* #__PURE__ */ RestrictionMixin;
export class AssignmentRestriction extends RestrictionMixin {
    static decode(input) {
        return AssignmentRestrictionParser.decode(input).map(res => new AssignmentRestriction(res));
    }
    static unsafeDecode(input) {
        return AssignmentRestriction.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AssignmentRestrictionParser.encode(data);
    }
    static schema() {
        return AssignmentRestrictionParser.schema();
    }
}
